module.exports = __webpack_public_path__ + "media/custom/images/img43-291c98a964915e91829a6767bbb22ded.jpg";